import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { USER_TOKEN_KEY } from "hooks/keys";
import { getStorage } from "hooks/useStorage";

interface AuthState {
    token: string | null;
}
const { removeItem, getItem, setItem } = getStorage('local');

const initialState: AuthState = {
    token: getItem(USER_TOKEN_KEY, null),
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setToken: (state, action: PayloadAction<string>) => {
            setItem(USER_TOKEN_KEY, action.payload);

            return {
                ...state,
                token: action.payload,
            }
        },
        logout: (state) => {
            removeItem(USER_TOKEN_KEY);
            return {
                ...state,
                token: null,
            };
        },
    },
});

export const {
    setToken, logout,
} = authSlice.actions;

export default authSlice.reducer;
